module.exports = __webpack_public_path__ + "static/media/logo.1036d0d5.png";